export default __webpack_public_path__ + "static/pineapple-e43733b0837f368d0132f9943d273c9f.jpg";